import React from 'react'

import { useHeaderContext } from '../Hooks/headerStates'

import { useStaticQuery, graphql } from 'gatsby'

import Logo from '../HeaderSharedComponents/Logo'
import MenuDesktop from '../HeaderSharedComponents/Menu/MenuDesktop'
import Burger from '../HeaderSharedComponents/Burger'
import NavLogo from './NavLogo'

import * as S from './styled'

const HeaderDesktop = ( {brand} ) => {

  const menuMobileCheck = useHeaderContext()
  const menuOpenState = menuMobileCheck.getMenuMobileOpenState()

  const scrollToTopMenu = () => {
    const menu = document.getElementById('menuMobile')
    const isFirefox = typeof InstallTrigger !== 'undefined'
    menu.scrollTo({ top: 0, left: 0, behavior: isFirefox ? 'auto' : 'smooth' })
  }

  const openMenuMobile = () => {
    menuMobileCheck.setMenuMobileOpenState(isOpen => !isOpen)
    menuMobileCheck.setSubmenuMobileVisibleState(false)
    scrollToTopMenu()
  }

  const { nav } = useStaticQuery(
    graphql`
      query {
        nav: wordpressWpGatsbyPage(slug: { eq: "home" }) {
          acf {
            nav_logo
            nav_link
            nav_image {
              localFile {
                url
              }
            }
          }
        }
      }
    `
  )

  const navLogo = nav.acf.nav_logo
  const navLink = nav.acf.nav_link
  const navImage = nav.acf.nav_image.localFile.url

  return (
    <>
      <S.Main>
        <Logo brand={brand} />
        <MenuDesktop />
        {
          navLogo &&
          <S.ContainerNavLogo>
            <NavLogo url={navLink} image={navImage} />
          </S.ContainerNavLogo>
        }
          {menuOpenState ?
            <>
            <S.Overlay
              id="MobileMenuOverlay-div"
              data-testid="MobileMenuOverlay-div"
              showOverlay={menuOpenState}
              onClick={openMenuMobile}
            />
              <S.ContainerLogoMenuBurger>
                <S.LogoMenuBurger />
              </S.ContainerLogoMenuBurger>
              <S.ContainerMenuLogoClose>
                <S.MenuButton onClick={openMenuMobile} data-testid="menuButton-button">
                  <S.MenuCloseIcon size="30" />
                </S.MenuButton>
              </S.ContainerMenuLogoClose>
            </> :
            <>
              <S.MenuText
                id="menuText-p"
                data-testid="menuText-p"
                onClick={openMenuMobile}
              >
                Menu
              </S.MenuText>
              <S.ContainerMenuLogo>

                <S.MenuButton onClick={openMenuMobile} data-testid="menuButton-button">
                  <S.MenuIcon size="30" />
                </S.MenuButton>
              </S.ContainerMenuLogo>
            </>
          }
      </S.Main>
      <Burger />
      <S.Line />
    </>
  )
}

export default HeaderDesktop
